import { Capacitor } from "@capacitor/core"

const nativeAuthTokenKey = "orbit.nativeAuthToken"
const nativeAuthPendingKey = "orbit.nativeAuthPending"

export const getNativeAuthToken = () => {
	if (!Capacitor.isNativePlatform() || typeof localStorage === "undefined")
		return null
	return localStorage.getItem(nativeAuthTokenKey)
}

export const setNativeAuthToken = (token: string) => {
	localStorage.setItem(nativeAuthTokenKey, token)
}

export const clearNativeAuthToken = () => {
	if (typeof localStorage === "undefined") return
	localStorage.removeItem(nativeAuthTokenKey)
}

// Arms the app-initiated pending login state a native auth deep link must
// echo back. Persisted so it survives cold starts; expires with the flow.
export const setPendingNativeAuth = () => {
	if (typeof localStorage === "undefined") return null
	const state = Array.from(crypto.getRandomValues(new Uint8Array(16)), (byte) =>
		byte.toString(16).padStart(2, "0")
	).join("")
	localStorage.setItem(
		nativeAuthPendingKey,
		JSON.stringify({ state, expiresAt: Date.now() + 5 * 60 * 1000 })
	)
	return state
}

export const consumePendingNativeAuth = (state: string) => {
	if (typeof localStorage === "undefined") return false
	const raw = localStorage.getItem(nativeAuthPendingKey)
	localStorage.removeItem(nativeAuthPendingKey)
	if (!raw) return false
	try {
		const pending = JSON.parse(raw) as { state?: string; expiresAt?: number }
		return (
			pending.state === state &&
			typeof pending.expiresAt === "number" &&
			pending.expiresAt > Date.now()
		)
	} catch {
		return false
	}
}
